import type { UsePreFilteredExtensionsQueryOptions } from '@atlassian/forge-ui/web-client/useExtensionList';

import { fg } from '@confluence/feature-gating';
import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient.ts';

type GetUsePrefilteredExtensionListOptionsParams = {
	cloudId: string;
	locale: string;
	moduleType: string;
	queryOptions?: any;
	includeHidden: boolean;
	spaceKey?: string;
	contentId?: string;
	attachmentId?: string;
	spaceContextOnly?: boolean;
};

export const getUsePrefilteredExtensionListOptions = ({
	cloudId,
	locale,
	moduleType,
	queryOptions,
	includeHidden,
	spaceKey,
	contentId,
	attachmentId,
	spaceContextOnly = false,
}: GetUsePrefilteredExtensionListOptionsParams): UsePreFilteredExtensionsQueryOptions => {
	const context = spaceContextOnly
		? { spaceKey }
		: {
				spaceKey,
				contentId,
				...(attachmentId && fg('forge_attachment_display_conditions') ? { attachmentId } : {}),
			};

	const options: UsePreFilteredExtensionsQueryOptions = {
		client: getAGGClient(),
		cloudId,
		types: [moduleType],
		queryOptions: {
			...queryOptions,
		},
		locale,
		context,
		includeHidden,
	};

	return options;
};
